(() => {
  function initialise(scope) {
    scope.querySelectorAll('.ki-belt-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      const root = gallery.closest('.ki-pdp');
      const prefix = gallery.dataset.configurator;
      const configurator = root && root.querySelector('.' + prefix);
      if (!configurator) return;
      gallery.dataset.ready = 'true';
      const pictures = Array.from(gallery.querySelectorAll('.ki-belt-radio'));
      const option = position => configurator.querySelector(`input[name="${prefix}-o${position}"]:checked`);
      const value = (input, position) => input ? input.id.slice((prefix + '-o' + position + '-').length) : '';

      function showSelection() {
        const price = root.querySelector('.ki-pdp-price');
        const selectedButton = Array.from(configurator.querySelectorAll('button[data-ki-price]'))
          .find(button => getComputedStyle(button).display !== 'none');
        if (price && selectedButton) price.textContent = selectedButton.dataset.kiPrice;
        const colour = value(option(1), 1);
        const buckle = value(option(2), 2);
        const picture = pictures.find(item => item.dataset.colour === colour && item.dataset.buckle === buckle);
        if (picture) picture.checked = true;
        // Each colour tile previews the currently selected buckle as well.
        configurator.querySelectorAll('.ki-cw-opt').forEach(label => {
          const radio = label.querySelector('input');
          const image = label.querySelector('img');
          const match = pictures.find(item => item.dataset.colour === value(radio, 1) && item.dataset.buckle === buckle);
          if (!match || !image) return;
          const source = gallery.querySelector(`.ki-belt-stage figure[data-belt-colour="${match.dataset.colour}"][data-belt-buckle="${match.dataset.buckle}"] img`);
          if (!source) return;
          const url = new URL(source.src);
          url.searchParams.set('width', '800');
          if (image.src !== url.href) image.src = url.href;
          image.alt = source.alt;
        });
      }
      configurator.addEventListener('change', event => {
        if (event.target.name && event.target.name.startsWith(prefix + '-o')) showSelection();
      });
      // A thumbnail selects its matching configuration, preventing an image / CTA mismatch.
      gallery.addEventListener('change', event => {
        const picture = event.target;
        if (!picture.matches('.ki-belt-radio')) return;
        for (const [position, selected] of [[1, picture.dataset.colour], [2, picture.dataset.buckle]]) {
          const input = configurator.querySelector(`[id="${prefix}-o${position}-${selected}"]`);
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        showSelection();
      });
      showSelection();
      window.addEventListener('pageshow', showSelection);
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
